import { action } from 'typesafe-actions';
// Fetch credits
export const FETCH_CREDITS_REQUEST = '[Request] Fetch credits';
export const FETCH_CREDITS_SUCCESS = '[Success] Fetch credits';
export const FETCH_CREDITS_FAILURE = '[Failure] Fetch credits';
export const fetchCreditsRequest = (address) => action(FETCH_CREDITS_REQUEST, { address });
export const fetchCreditsSuccess = (address, credits) => action(FETCH_CREDITS_SUCCESS, { address, credits });
export const fetchCreditsFailure = (address, error) => action(FETCH_CREDITS_FAILURE, { address, error });
// Poll Credits Balance
export const POLL_CREDITS_BALANCE_REQUEST = '[Request] Poll credits balance';
export const pollCreditsBalanceRequest = (address, expectedBalance) => action(POLL_CREDITS_BALANCE_REQUEST, { address, expectedBalance });
//# sourceMappingURL=actions.js.map